import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";


@Injectable({
	providedIn: 'root'
})

export class BreadcrumbService {

	private _breadcrumbId$ = new BehaviorSubject<string>("");

	get breadcrumbId$() {
		return this._breadcrumbId$.asObservable();
	}

	setBreadcrumbId(id: string) {
		this._breadcrumbId$.next(id);
	}
}
